import React from "react";

export const HowRevokeAlbum: React.FC = () => {
  return <div id={"HowRevokeAlbum"}>
    <h2>
      Как изъять альбом
    </h2>
    <p>
      Вы можете изъять альбом с помощью соответсвующей кнопки на странице альбома:
      <div className={"text-center"}>
        <img className={"max-h-[350px]"} src={"/help/revoke_album.jpg"} alt={"Изъять альбом"} />
      </div>
    </p>
    <p>
      Вы также можете выбрать сразу несколько альбомов из вашего каталога на странице "Альбомы" и изъять их:
    </p>
    <div className={"text-center"}>
      <img className={"max-h-[350px]"} src={"/help/revoke_albums.jpg"} alt={"Изъять альбом"} />
    </div>
    <p className={"mt-3"}>
      Обратите внимание, что изъятие альбома подразумевает полный отзыв вашей лицензии: официальный плейлист
      блокируется, пользовательские треки при этом остаются доступными.
      Если необходимо сделать альбом или отдельные треки недоступным для прослушивания без отзыва лицензии, установите
      финансовую модель "Блокировка" на все или выборочные треки.
    </p>
  </div>;
};
